import axiosInstance from '../../../services/axios/axios';
import { then } from '../../../services/axios/_utility';

/**
 * Fetch application details for a particular account
 *
 * @function
 * @param {number} esoFiId T_ESO.FI_ID of the target account
 * @returns {Promise} resolved promise of app details if existing, otherwise null.
 */
export const getAppDetails = async esoFiId => {
	return axiosInstance
		.get(`/api/UserAccessReview/GetUserServiceAccountApps/${esoFiId}`)
		.then(response => {
			return then(response, payload => payload);
		})
		.catch(error => {
			throw error;
		});
};
